export default __webpack_public_path__ + "static/media/contact-3.6ddfa5e5.png";